import { RULE_TYPE } from "Types/automationTypes";

export function getRuleColumnVisibility(ruleType) {
    const isAction = ruleType === RULE_TYPE.action;
    const isValidation = ruleType === RULE_TYPE.validation;
    const isProgramWideProject = ruleType === RULE_TYPE.programWideProject;
    const isProgram = ruleType === RULE_TYPE.program;

    return {
        showOrder: isAction || isProgramWideProject,
        showFrequency: isAction || isValidation,
        showCondition: true,
        showErrorMessage: isValidation,
        showAction: isAction || isProgramWideProject || isProgram,
        showContinueProcessing: isAction
    };
}
